import { scale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  containerStyle: { alignItems: 'center', height: scale(140), justifyContent: 'center' },
  imageStyle: { height: '100%', width: '100%' },
});
export default styles;
